import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 9,
        label: 'MENUITEMS.APPS.TEXT',
        isTitle: true
    },
    {
        id: 166,
        label: 'Home',
        icon: 'bx-home',
        link: '/events/home',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 169,
        label: 'Talks',
        isTitle: true
    },
    {
        id: 161,
        label: 'Presentations',
        icon: 'bx-chalkboard',
        link: '/events/presentations',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 162,
        label: 'Sessions',
        icon: 'bx-layer',
        link: '/events/sessions',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 172,
        label: 'Venues & Floor Maps',
        icon: 'bx-map',
        link: '/events/venues',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 174,
        label: 'Statistics',
        icon: 'bx-stats',
        link: '/events/statistics',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 170,
        label: 'Organization',
        isTitle: true
    },
    {
        id: 145,
        label: 'Sponsors',
        icon: 'bx-rocket',
        link: '/events/sponsors',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 160,
        label: 'Committees',
        icon: 'bx-briefcase-alt',
        link: '/events/committees',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 171,
        label: 'Interaction',
        isTitle: true
    },
    {
        id: 163,
        label: 'Participants',
        icon: 'bx-user',
        link: '/events/participants',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 178,
        label: 'Q&A',
        icon: 'bx-question-mark',
        link: '/events/qna',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 164,
        label: 'Discussions',
        icon: 'bx-comment-dots',
        link: '/events/discussions',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 167,
        label: 'Inbox',
        icon: 'bx-voicemail',
        link: '/events/inbox',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 145,
        label: 'MENUITEMS.EVENTS.LIST.TEXT',
        icon: 'bx-calendar',
        link: '/',
    }
];

